<template>
  <i-select
    :value="value"
    :filterable="true"
    :clearable="true"
    :loading="only_user_data ? isLoading : is_loading"
    :multiple="multiple"
    v-on="$listeners"
  >
    <template v-if="!multiple && items.length > 0 && codes.length > 0">
      <i-option v-for="item in items" :key="item.id" :value="item.iso" :label="item.label" />
    </template>
    <template v-if="multiple && items.length > 0 && codes.length > 0">
      <i-option v-for="item in items" :key="item.id" :value="item.code" :label="item.label" />
    </template>
  </i-select>
</template>

<script>
  import { CountryService } from '@core/services/CountryService';
  import { mapGetters } from 'vuex';
  import axios from 'axios';

  export default {
    props: {
      value: {
        type: [String, Number],
        default: null
      },
      multiple: {
        type: Boolean,
        default: false
      },

      only_user_data: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        is_loading: true,
        codes: [],
        items: []
      };
    },

    computed: {
      ...mapGetters('phone-number/user_countries/list', ['countries', 'isLoading'])
    },

    created() {
      if (this.only_user_data) {
        this.codes = this.countries.map((i) => ({ code: i.code, country: i.country }));
        this.items = this.countries.map((i) => ({ ...i, label: `${i.country} +${i.code}` }));
      } else {
        axios.all([CountryService.getSelect(), CountryService.getCountriesCodes()]).then(
          axios.spread((titles, codes) => {
            this.codes = codes;
            this.items = codes.map((i) => ({
              ...i,
              id: Math.floor(Math.random() * 1000) + 1,
              iso: titles.filter((k) => k.country === i.country)[0].iso,
              label: `${i.country} +${i.code}`
            }));

            this.is_loading = false;
          })
        );
      }
    }
  };
</script>
